import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ServidorSelecionadoService {

  public onInformacoesSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  public salvarFuncionarioSelecionado(funcionario: any) {

    if (funcionario.id) {

      this.onInformacoesSubject.next(funcionario);
    }
  }

  clear() {
    this.onInformacoesSubject.next(null);
  }

  public onSelecionarFuncionario(): Observable<any> {
    return this.onInformacoesSubject.asObservable();
  }
}
